import IconBtn from "../../Assets/IconBtn/IconBtn"
import { useRef, useState } from "react"
import clsx from "clsx"
import { useOnClickOutside } from "../../../hooks/useOnClickOutside"
import SearchSelect from "../../SearchSelect/SearchSelect"
import { IEmployee } from "../../../types/content"
import styles from "./MessagesModalUsers.module.scss"

interface Props {
  onClick?: (userID: string, name: string, projectID: string) => void
  className?: string
}

const MessagesModalUsers = ({ onClick, className }: Props) => {
  const wrapRef = useRef<HTMLDivElement>(null)
  const [isOpen, setOpen] = useState<boolean>(false)
  const [searchedUser, setSearchedUser] = useState<{
    project_id: string
    project_name: string
    user: IEmployee
  } | null>(null)

  useOnClickOutside(wrapRef, () => {
    if (isOpen) setOpen(false)
  })

  return (
    <div className={clsx(styles.wrap, className)} ref={wrapRef}>
      <IconBtn icon={"plus"} borderSize={"sm"} mode={"gray"} size={"sm"} onClick={() => setOpen((prev) => !prev)} />
      {isOpen && (
        <div className={styles.drop}>
          <SearchSelect
            setSelectedVal={setSearchedUser}
            selectedVal={searchedUser}
            className={styles["search-select"]}
            isShortClick={(userID, name, projectID) => {
              if (onClick) onClick(userID, name, projectID)
              setOpen(false)
            }}
          />
        </div>
      )}
    </div>
  )
}

export default MessagesModalUsers
